import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAsaU-zvc853aF9tbyNFV3B6lkwDioT5dQ",
  authDomain: "roofingprohtx.firebaseapp.com",
  projectId: "roofingprohtx",
  storageBucket: "roofingprohtx.firebasestorage.app",
  messagingSenderId: "286846345880",
  appId: "1:286846345880:web:b1ce0b28c6955cb93166ed",
  measurementId: "G-0LRX8H1ECT"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);